export enum EShopifyPlanNames {
  ESSENTIAL = 'Essential',
  TRIAL = 'Trial',
  PRO = 'Pro'
}

export const shopifyPlans = [
  {
    name: EShopifyPlanNames.ESSENTIAL,
    stripeIds: {
      product: process.env.REACT_APP_STRIPE_SHOPIFY_PRODUCT_KEY,
      monthly: process.env.REACT_APP_STRIPE_SHOPIFY_MONTHLY_ID,
      yearly: process.env.REACT_APP_STRIPE_SHOPIFY_YEARLY_ID,
    },
    defaultPlan: {
      from: 0,
      to: 10,
      cost: 0,
    },
    monthlyCost: [],
    annualyCost: [],
  },
];
